import { AwsComponentKey } from "@p0security/integrations-aws-shared/types";
import { AzureComponentKey } from "@p0security/integrations-azure-shared/types";
import {
  GcloudIamComponentKey,
  GcloudSecurityPerimeterComponentKey,
} from "@p0security/integrations-gcloud-shared/types";

export const WelcomeFlows = {
  JIT: "jit",
  ASSESSMENT: "assessment",
} as const;

export type SupportedCloudProviders = "aws" | "azure" | "gcloud";

export type CloudProviderParams = {
  cloudProvider: SupportedCloudProviders;
  component:
    | AwsComponentKey
    | AzureComponentKey
    | GcloudIamComponentKey
    | GcloudSecurityPerimeterComponentKey;
} & (
  | {
      cloudProvider: "aws";
      component: AwsComponentKey;
    }
  | {
      cloudProvider: "azure";
      component: AzureComponentKey;
    }
  | {
      cloudProvider: "gcloud";
      component: GcloudIamComponentKey | GcloudSecurityPerimeterComponentKey;
    }
);
